import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default (env, state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${env.toUpperCase()}__SET_USERSMANAGERS`:
            return core.setUsersManagers(state, action.usersManagers);
        case `${env.toUpperCase()}__UPDATE_USERSMANAGERS`:
            return core.updateUsersManagers(state, action.usersManagers);
        case `${env.toUpperCase()}__UPDATE_USERMANAGER`:
            return core.updateUserManager(state, action.userManagerId, action.userManager);
        case `${env.toUpperCase()}__SET_USERMANAGER`:
            return core.setUserManager(state, action.userManagerId, action.userManager);
        case `${env.toUpperCase()}__DELETE_USERSMANAGER`:
            return core.setUserManager(state, action.userManagerId);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/UsersManagers/reducer.js